import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowAltSquareRight, faTimes } from '@fortawesome/pro-regular-svg-icons';
import {
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
} from "@mui/material";
import AllEmployeeOffersReport from '../AllEmployeeOffersReport';
import './EmployeeOffers.scss';

const classSufix = "employee-offers";

const EmployeeOffers = () => {
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'billboard.allEmployeeReports' });
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    return (
        <div className="employee-offers">
            <span className='section-title'>{t('employeeOffers')}</span>
            <div className='section-content'>
                <div className='section-item'>
                    <div onClick={() => setIsModalOpen(true)}>
                        {t('allEmployeeOffersView')}
                    </div>
                </div>
                <div className='section-item'>
                    <IconButton onClick={() => setIsModalOpen(true)} size="large">
                        <FontAwesomeIcon icon={faArrowAltSquareRight} />
                    </IconButton>
                </div>
            </div>
            <Dialog
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                className={`${classSufix}-modal`}
                fullWidth
                maxWidth="lg"
            >
                <DialogTitle
                    id={`${classSufix}-header`}
                    className={`${classSufix}-header`}
                >
                    <div>
                        <span className={`${classSufix}-title`}>
                            {t('allEmployeeOffersView')}
                        </span>
                    </div>
                    <div>
                        <IconButton onClick={() => setIsModalOpen(false)} size="large">
                            <FontAwesomeIcon icon={faTimes} />
                        </IconButton>
                    </div>
                </DialogTitle>
                <DialogContent sx={{ paddingTop: '20px !important' }}>
                    <AllEmployeeOffersReport />
                </DialogContent>
            </Dialog>
            <hr />
        </div>
    );
};

export default EmployeeOffers;
